<template>
  <div class="create-account">
    <div class="logo">
      <img src="../assets/images/powerslide-blue.svg" alt="Powerslide Logo" v-on:click="home" />
    </div>

    <div class="create-account-container" v-if="!createdUser">
      <div class="message" v-bind:class="{error: validation.hasError('firstName')}">{{ validation.firstError('firstName') }}</div>
      <input type="text" v-bind:class="{errorInput: validation.hasError('firstName')}" v-model="firstName" placeholder="First Name" maxlength="20" />

      <div class="message" v-bind:class="{error: validation.hasError('lastName')}">{{ validation.firstError('lastName') }}</div>
      <input type="text" v-bind:class="{errorInput: validation.hasError('lastName')}" v-model="lastName" placeholder="Last Name" maxlength="20" />

      <div class="message" v-bind:class="{error: validation.hasError('email')}">{{ validation.firstError('email') }}</div>
      <input type="text" v-bind:class="{errorInput: validation.hasError('email')}" v-model="email" placeholder="Email" maxlength="40" />

      <div class="message" v-bind:class="{error: validation.hasError('phone')}">{{ validation.firstError('phone') }}</div>
      <input type="phone" v-bind:class="{errorInput: validation.hasError('phone')}" v-model="phone" placeholder="Phone" maxlength="10" />

      <div class="message" v-bind:class="{error: validation.hasError('password')}">{{ validation.firstError('password') }}</div>
      <input type="password" v-bind:class="{errorInput: validation.hasError('password')}" v-model="password" placeholder="Password" />

      <div class="error-response" v-if="createAccountError">
        Error: {{errorMessage}}
      </div>

      <div class="button" v-on:click="createAccount">Create Account</div>

      <div class="login-link" v-on:click="login">
        Already have an account? Login
      </div>
    </div>

    <div class="create-account-success" v-if="createdUser">
      <h2>Success!</h2>
      <div>
        Your account has been created. You will receive an activation email at <span>{{email}}</span>
      </div>

      <div class="return-to-login" v-on:click="login">
        Click here to return to the login page.
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Helpers from '../mixins/helpers.js'
import SimpleVueValidation from 'simple-vue-validator'
import '../styles/base.css'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'CreateAccount',
  data () {
    return {
      createAccountError: false,
      createdUser: false,
      email: '',
      errorMessage: '',
      firstName: '',
      lastName: '',
      password: '',
      phone: ''
    }
  },

  mounted () {

  },

  methods: {
    createAccount: function () {
      this.$validate().then((success) => {
        if (success) {
          let data = {
            email: this.email,
            first_name: this.firstName,
            last_name: this.lastName,
            password: this.password,
            phone: this.phone,
            role: 'owner'
          }

          axios.post('/api/user', data)
            .then((response) => {
              this.$gtag.event('account-created', { method: 'Google' })
              this.createdUser = true
            })
            .catch((err) => {
              this.errorMessage = err.response.data.error
              this.createAccountError = true
            })
        }
      })
    },

    login: function () {
      this.$router.push('/login')
    },

    home: function () {
      this.$router.push('/')
    }
  },

  mixins: [Helpers],

  validators: {
    email: function (value) {
      return Validator.value(value).required().email()
    },

    firstName: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    },

    lastName: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    },

    password: function (value) {
      return Validator.custom(function () {
        if (!Validator.isEmpty(value)) {
          if (value.length < 6) {
            return 'Must contain at least 6 characters'
          }
        }
      })
    },

    phone: function (value) {
      return Validator.value(value).required().digit().length(10)
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 400px;
  }

  .create-account {
    align-items: center;
    background-color: white;
    height: 100vh;
    margin: 0 auto;
    overflow: auto;
    position: relative;
    width: 100vw;
  }

  .create-account-container {
    margin: 0 auto;
    position: relative;
    width: 400px;
  }

  .create-account-success {
    background: white;
    margin: 3em auto;
    padding: 1em;
    position: relative;
    text-align: center;
    width: 400px;
  }

  .error-response {
    color: var(--error);
    margin-top: 1em;
  }

  .form-group {
    text-align: left;
  }

  h2 {
    margin: 0;
  }

  img {
    cursor: pointer;
    height: 100px;
  }

  input {
    border: 1px solid var(--border-grey);
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: .5em;
    padding: 1em;
    width: 400px;
  }

  input:focus {
    outline: 5px solid var(--focus);
  }

  .login-link {
    cursor: pointer;
    padding: 2em;
    text-align: center;
  }

  .login-link:hover {
    color: var(--secondary-dark);
  }

  .logo {
    margin: 6em auto 2em;
    text-align: center;
  }

  .message {
    height: 22px;
    margin-bottom: .5em;
    text-align: left;
  }

  .return-to-login {
    cursor: pointer;
    padding: 1em;
    text-align: center;
  }

  .return-to-login:hover {
    color: var(--secondoary-dark);
  }

  span {
    color: var(--primary);
  }

  @media only screen and (max-width: 420px) {
    .button {
      width: 300px;
    }

    .create-account-container {
      width: 300px;
    }

    .create-account-success {
      width: 300px;
    }

    img {
      width: 300px;
    }

    input[type=text], input[type=phone], input[type=email], input[type=password], textarea {
      width: 300px;
    }

    .logo {
      margin: 4em auto 0em;
    }
  }
</style>
